import { MsalAuthenticationResult } from "@azure/msal-react";
import { Topbar } from "@kamstrup/flow-ui/layout";
import { ErrorPage } from "@kamstrup/flow-core/guardian";
import { TopBarContent } from "src/features/application";

export const AuthErrorComponent: React.FC<MsalAuthenticationResult> = () => {
  //This is an simpel example using the error response, or just showing a generic message:
  const errorMessage = "An error happened during the authentication process.";

  return (
    <ErrorPage
      topbar={
        <Topbar>
          <TopBarContent />
        </Topbar>
      }
      message={errorMessage}
    />
  );
};

